import { GridBoxList } from '@factorialco/deprecated-design-system'
import {
  type PermissionsEntitiesPermissionGroupKindEnum,
  PermissionsPermissionsDocument,
} from 'generated/resources/graphql'

import { observer } from 'mobx-react'

import { useQuery } from 'modules/core/hooks/useQuery'

import permissionGroups from 'modules/permissions/store/collections/permissionGroups'

import Item from './Item'

const SORT_ORDER: Array<PermissionsEntitiesPermissionGroupKindEnum> = [
  'admin',
  'default',
  'onboarding',
  'custom',
]

const PermissionGroups = () => {
  const { data } = useQuery(PermissionsPermissionsDocument, {})

  const memberCounts = new Map<number, number>()
  data?.permissions.permissionGroups.forEach((group) => {
    const count = group.membersConnection.totalCount
    if (count !== null && count !== undefined) {
      memberCounts.set(group.id, count)
    }
  })

  const groups = [...permissionGroups.models]
  groups.sort((a, b) => {
    return SORT_ORDER.indexOf(a.attributes.kind) - SORT_ORDER.indexOf(b.attributes.kind)
  })

  return (
    <GridBoxList>
      {groups.map((group) => {
        return (
          <Item
            key={group.id}
            permissionGroup={group}
            memberCount={memberCounts.get(group.id) ?? 0}
            canDuplicate={data?.permissions._policies.groupDuplicate.can ?? false}
            canApplyRoleTemplates={data?.permissions._policies.roleTemplateApply.can ?? false}
            canEditGroup={data?.permissions._policies.groupEdit.can ?? false}
          />
        )
      })}
    </GridBoxList>
  )
}

export default observer(PermissionGroups)
